// src/store/reducers/index.js
import { combineReducers } from "redux";
import userReducer from "./user/reducer";
import settingsReducer from "./settings/reducer";

const rootReducer = combineReducers({
  user: userReducer,
  settings: settingsReducer,
});

export default rootReducer;
